module.exports = __webpack_public_path__ + "static/media/sunny.36fb1d98.jpg";